<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <h1 class="text-center">Counter Service</h1>
    <div class="form shadow p-4 mb-5 bg-white rounded no-margin-rows">
      <div class="row">
        <div class="col-6">
          <label for="brandBox">Brand</label>
          <input
            id="brandBox"
            v-model="brandName"
            type="text"
            class="form-control"
            readonly
          />
        </div>
      </div>
      <div class="row mb-5">
        <div class="col">
          <label for="storeCodeBox">Store code</label>
          <input
            id="storeCodeBox"
            v-model="storeCode"
            type="text"
            class="form-control"
            readonly
          />
        </div>
        <div class="col">
          <label for="storeNameBox">Store name</label>
          <input
            id="storeNameBox"
            v-model="storeName"
            type="text"
            class="form-control"
            readonly
          />
        </div>
      </div>
      <v-tabs v-model="activeTab" class="custom-tabs">
        <v-tab>Services</v-tab>
        <v-tab>Rooms</v-tab>
        <v-tab>Staffs</v-tab>
      </v-tabs>
      <div>
        <v-tabs-items v-model="activeTab">
          <v-tab-item class="tab-content">
            <div class="services pt-5">
              <strong>Services</strong>
              <div class="row mb-2">
                <div class="col-3 d-flex align-items-center">
                  <input
                    type="checkbox"
                    id="select-all-services"
                    :checked="areAllServicesChecked"
                    @change="toggleAllServices($event.target.checked)"
                    class="form-check-input mr-2"
                    :disabled="!hasEditPermission"
                  />
                  <label class="form-check-label mt-1" for="select-all-services">
                    Select All
                  </label>
                </div>
              </div>
              <div
                v-for="(service, index) in serviceMasterList"
                :key="index"
                class="row"
              >
                <div class="col-3 d-flex align-items-center">
                  <input
                    type="checkbox"
                    :id="'checkbox-' + index"
                    v-model="service.isChecked"
                    class="form-check-input mr-2"
                    :disabled="!hasEditPermission"
                  />
                  <label class="form-check-label" :for="'checkbox-' + index">
                    {{ service.nameTh }}
                  </label>
                </div>
                <div class="col-3">
                  <label :for="'start-date-' + index"
                    >Start date<span v-if="service.isChecked" class="required"
                      >*</span
                    ></label
                  >
                  <div class="d-flex align-items-center">
                    <DatePicker
                      :id="'start-date-' + index"
                      v-bind="$attrs"
                      v-model="service.startDate"
                      format="DD/MM/yyyy"
                      lang="en"
                      :value="service.startDate"
                      @change="
                        changeStartDate(service, $event);
                        service.startDate = $event;
                      "
                      :setDisable="!service.isChecked"
                      style="margin-top: -0.6rem"
                    />
                    <button
                      type="button"
                      @click="service.startDate = null"
                      class="btn btn-outline-secondary ml-1"
                      style="height: calc(100%); white-space: nowrap"
                      v-if="hasEditPermission"
                    >
                      Clear
                    </button>
                  </div>
                  <div
                    v-if="isSubmit && error.errorStartDate && service.isChecked"
                    class="text-error"
                  >
                    {{ error.errorStartDate.message }}
                  </div>
                </div>
                <div class="col-3">
                  <label :for="'end-date-' + index">End date</label>
                  <div class="d-flex align-items-center">
                    <DatePicker
                      :id="'end-date-' + index"
                      v-bind="$attrs"
                      v-model="service.endDate"
                      format="DD/MM/yyyy"
                      lang="en"
                      @change="
                        changeEndDate(service, $event);
                        service.endDate = $event;
                      "
                      :value="service.endDate"
                      :minDate="service.startDate"
                      :setDisable="!service.isChecked"
                      style="margin-top: -0.6rem"
                    />
                    <button
                      type="button"
                      @click="service.endDate = null"
                      class="btn btn-outline-secondary ml-1"
                      style="height: calc(100%); white-space: nowrap"
                      v-if="hasEditPermission"
                    >
                      Clear
                    </button>
                  </div>
                  <div
                    v-if="isSubmit && error.errorEndDate && service.isChecked"
                    class="text-error"
                  >
                    {{ error.errorEndDate.message }}
                  </div>
                </div>
              </div>
              <div class="pt-10 pb-10">
                <strong>Service time</strong>
                <table class="mt-5 w-100">
                  <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        class="form-check-input mr-2"
                        id="select-all-days"
                        :checked="areAllDaysSelected"
                        @change="toggleAllShifts($event.target.checked)"
                      />
                      <label class="form-check-label" for="select-all-days">
                        Select All
                      </label>
                    </th>
                    <th colspan="3">Shift A</th>
                    <th colspan="3">Shift B</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(day, index) in days" :key="day.value">
                    <td>
                      <input
                          type="checkbox"
                          :id="'shift-checkbox-' + index"
                          :checked="shiftMap[day.value]['A'].isActive && shiftMap[day.value]['B'].isActive"
                          @change="toggleShifts(day.value, $event.target.checked)"
                          class="form-check-input mr-2"
                      />
                      <label class="form-check-label" :for="'shift-checkbox-' + index">
                        {{ day.label }}
                      </label>
                      <div
                          v-if="error.errorShifts[`isActive.${day.value}`]"
                          class="text-error"
                      >
                        {{ error.errorShifts[`isActive.${day.value}`].message }}
                      </div>
                    </td>
                    <td class="pr-4 time-picker-wrapper">
                      <TimePicker
                          :id="'shiftA-startTimePicker-' + index"
                          v-model="shiftMap[day.value]['A'].startTime"
                          label="Start time<span class='required'>*</span>"
                          format="24hr"
                          :allowed-minutes="[0, 15, 30, 45]"
                          :disabled="!shiftMap[day.value]['A'].isActive"
                      />
                      <div
                          v-if="isSubmit
                                && error.errorShifts[day.value]
                                && error.errorShifts[day.value].A
                                && error.errorShifts[day.value].A.startDate"
                          class="text-error"
                          style="margin-top: -1rem"
                      >
                        {{ error.errorShifts[day.value].A.startDate.message }}
                      </div>
                      <div
                          v-if="isSubmit
                                && error.errorShifts[day.value]
                                && error.errorShifts[day.value].A
                                && error.errorShifts[day.value].A.startTime"
                          class="text-error"
                          style="margin-top: -1rem"
                      >
                        {{ error.errorShifts[day.value].A.startTime.message }}
                      </div>
                    </td>
                    <td class="pr-4 time-picker-wrapper">
                      <TimePicker
                          :id="'shiftA-endTimePicker-' + index"
                          v-model="shiftMap[day.value]['A'].endTime"
                          label="End time<span class='required'>*</span>"
                          format="24hr"
                          :allowed-minutes="[0, 15, 30, 45]"
                          :disabled="!shiftMap[day.value]['A'].isActive"
                      />
                      <div
                          v-if="isSubmit
                                && error.errorShifts[day.value]
                                && error.errorShifts[day.value].A
                                && error.errorShifts[day.value].A.endDate"
                          class="text-error"
                          style="margin-top: -1rem"
                      >
                        {{ error.errorShifts[day.value].A.endDate.message }}
                      </div>
                      <div
                          v-if="isSubmit
                                && error.errorShifts[day.value]
                                && error.errorShifts[day.value].A
                                && error.errorShifts[day.value].A.endTime"
                          class="text-error"
                          style="margin-top: -1rem"
                      >
                        {{ error.errorShifts[day.value].A.endTime.message }}
                      </div>
                    </td>
                    <td class="pr-4">
                      <button
                          class="btn btn-outline-primary btn-sm"
                          :disabled="!shiftMap[day.value]['A'].isActive
                          || !shiftMap[day.value]['A'].startTime
                          || !shiftMap[day.value]['A'].endTime"
                          @click="applyAllShiftTimes('A', day.value)"
                      >
                        Apply All
                      </button>
                    </td>
                    <td class="pr-4 time-picker-wrapper">
                      <TimePicker
                          :id="'shiftB-startTimePicker-' + index"
                          v-model="shiftMap[day.value]['B'].startTime"
                          label="Start time<span class='required'>*</span>"
                          format="24hr"
                          :allowed-minutes="[0, 15, 30, 45]"
                          :disabled="!shiftMap[day.value]['A'].isActive"
                      />
                      <div
                          v-if="isSubmit
                                && error.errorShifts[day.value]
                                && error.errorShifts[day.value].B
                                && error.errorShifts[day.value].B.startDate"
                          class="text-error"
                          style="margin-top: -1rem"
                      >
                        {{ error.errorShifts[day.value].B.startDate.message }}
                      </div>
                      <div
                          v-if="isSubmit
                                && error.errorShifts[day.value]
                                && error.errorShifts[day.value].B
                                && error.errorShifts[day.value].B.startTime"
                          class="text-error"
                          style="margin-top: -1rem"
                      >
                        {{ error.errorShifts[day.value].B.startTime.message }}
                      </div>
                    </td>
                    <td class="pr-4 time-picker-wrapper">
                      <TimePicker
                          :id="'shiftB-endTimePicker-' + index"
                          v-model="shiftMap[day.value]['B'].endTime"
                          label="End time<span class='required'>*</span>"
                          format="24hr"
                          :allowed-minutes="[0, 15, 30, 45]"
                          :disabled="!shiftMap[day.value]['A'].isActive"
                      />
                      <div
                          v-if="isSubmit
                                && error.errorShifts[day.value]
                                && error.errorShifts[day.value].B
                                && error.errorShifts[day.value].B.endDate"
                          class="text-error"
                          style="margin-top: -1rem"
                      >
                        {{ error.errorShifts[day.value].B.endDate.message }}
                      </div>
                      <div
                          v-if="isSubmit
                                && error.errorShifts[day.value]
                                && error.errorShifts[day.value].B
                                && error.errorShifts[day.value].B.endTime"
                          class="text-error"
                          style="margin-top: -1rem"
                      >
                        {{ error.errorShifts[day.value].B.endTime.message }}
                      </div>
                    </td>
                    <td>
                      <button
                          class="btn btn-outline-primary btn-sm"
                          :disabled="!shiftMap[day.value]['B'].isActive
                           || !shiftMap[day.value]['B'].startTime
                           || !shiftMap[day.value]['B'].endTime"
                          @click="applyAllShiftTimes('B', day.value)"
                      >
                        Apply All
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-flex justify-content-end">
                <button class="btn btn-outline-success ml-10"
                        @click="onSubmit"
                        v-if="hasEditPermission">
                  Save
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div class="d-flex align-items-center justify-content-start">
                  <span>
                    <strong>Last updated: </strong> &nbsp;
                    {{ lastUpdated }}</span
                  >
                </div>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item class="tab-content tab-min-height">
            <ListResource
                ref="rooms"
              resource-name="Rooms"
              resource-type="ROOM"
              :store-code="storeCode"
              :has-edit-permission="hasEditPermission"
            />
          </v-tab-item>
          <v-tab-item class="tab-content tab-min-height">
            <ListResource
                ref="staffs"
                resource-name="Staffs"
              resource-type="STAFF"
              :store-code="storeCode"
              :has-edit-permission="hasEditPermission"
            />
          </v-tab-item>
        </v-tabs-items>
      </div>
      <div class="d-flex justify-content-end mt-2">
        <button class="btn btn-primary text-white" @click="$router.go(-1)">
          Back
        </button>
      </div>
    </div>
    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog">
        <h3>{{ message }}</h3>
        <div class="row text-center">
          <div v-if="showSuccess && storeCode" class="col-12">
            <button class="btn-back" @click="setDefault">ตกลง</button>
          </div>
          <div v-if="showSuccess" class="col-12">
            <button
              class="btn-back"
              @click="
                () =>
                  $router.push({
                    name: 'StoreMaster',
                  })
              "
            >
              กลับสู่หน้าหลัก
            </button>
          </div>
        </div>
        <div v-if="!showSuccess" class="row text-center">
          <div class="col">
            <button class="btn-back" @click="showDialog = false">ปิด</button>
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import ServiceMasterService from "services/api/serviceMaster.service";
import CounterServiceService from "services/api/counterService.service";
import moment from "moment/moment";
import DatePicker from "components/Datepicker/Datepicker.vue";
import TimePicker from "components/Timepicker/TimePicker.vue";
import ListResource from "./ListResource.vue";
import { TokenService } from "services/storage.service";

export default {
  components: {TimePicker, DatePicker, ListResource },
  data() {
    return {
      message: null,
      showDialog: false,
      brandCode: null,
      brandName: null,
      storeCode: null,
      storeName: null,
      isLoading: false,
      isSubmit: false,
      showSuccess: false,
      lastUpdated: null,
      totalServices: 0,
      serviceMasterList: [],
      activeTab: this.$route.query.tab ? Number(this.$route.query.tab) : 0,
      hasEditPermission: false,
      form: {
        services: [],
        brandName: null,
        storeCode: null,
        storeName: null,
        lastUpdated: null,
        shifts: [],
      },
      days: [
        { label: "จันทร์", value: "MONDAY" },
        { label: "อังคาร", value: "TUESDAY" },
        { label: "พุธ", value: "WEDNESDAY" },
        { label: "พฤหัส", value: "THURSDAY" },
        { label: "ศุกร์", value: "FRIDAY" },
        { label: "เสาร์", value: "SATURDAY" },
        { label: "อาทิตย์", value: "SUNDAY" },
        { label: "Public Holiday", value: "PUBLIC_HOLIDAY" },
      ],
      error: {
        errorServiceIds: "",
        errorStartDate: "",
        errorEndDate: "",
        errorShifts: {}
      },
    };
  },

  async mounted() {
    if (this.$route.query.tab != null) {
      this.activeTab = Number(this.$route.query.tab);
    }
    const details = sessionStorage.getItem("storeDetails");
    if (details) {
      const parsedDetails = JSON.parse(details);
      this.brandCode = parsedDetails.brandCode;
      this.brandName = parsedDetails.brandName;
      this.storeCode = parsedDetails.storeCode;
      this.storeName = parsedDetails.displayName ?? parsedDetails.name;

      if (this.brandCode && this.storeCode) {
        this.isLoading = true;
        await this.getServiceMasters();
        await this.getCounterService();
      }

      const userRole = JSON.parse(TokenService.getUserRoles());
      const editRoles = new Set([
        "ROLE_ADMIN",
        "ROLE_BRAND_ADMIN",
        "ROLE_SALES_SUPERVISOR",
      ]);

      this.hasEditPermission = userRole.some(u => editRoles.has(u));
    } else {
      await this.$router.push({ name: "StoreMaster" });
    }
  },
  computed: {
    shiftMap() {
      const map = {};
      this.days.forEach(day => {
        map[day.value] = {
          A: { startTime: "", endTime: "" },
          B: { startTime: "", endTime: "" }
        };
      });
      this.form.shifts.forEach(shift => {
        if (map[shift.day]) {
          map[shift.day][shift.name] = shift;
        }
      });
      return map;
    },
    areAllServicesChecked() {
      return this.serviceMasterList.length > 0 &&
        this.serviceMasterList.every(service => service.isChecked);
    },
    areAllDaysSelected() {
      return this.days.every(day =>
        this.shiftMap[day.value]['A'].isActive &&
        this.shiftMap[day.value]['B'].isActive
      );
    },
  },
  methods: {
    onSubmit() {
      this.isSubmit = true;
      this.isLoading = true;
      this.showSuccess = false;
      this.resetErrorText();
      const body = {
        services: this.serviceMasterList
          .filter((service) => service.isChecked)
          .map((service) => ({
            id: service.id,
            startDate: service.startDate
              ? this.convertToISO8601(service.startDate)
              : null,
            endDate: service.endDate
              ? this.convertToISO8601(service.endDate)
              : null,
          })),
        shifts: this.form.shifts,
      };
      this.upsertCounterService(this.storeCode, body);
    },
    async setDefault() {
      this.showDialog = false;
      this.isSubmit = false;
    },
    async getServiceMasters() {
      const params = this.getServiceParams();
      await ServiceMasterService.getListServiceMaster(params)
        .then((res) => {
          const data = res.data;
          this.totalItems = data.totalItems;
          this.isLoading = false;
          this.serviceMasterList = data.services.map((service) => ({
            ...service,
            startDate: null,
            endDate: null,
            isChecked: false,
          }));
        })
        .catch((err) => {
          console.log("Error: ", err);
          this.isLoading = false;
        });
    },
    async getCounterService() {
      this.isLoading = true;
      try {
        await CounterServiceService.getCounterService(this.storeCode).then(
          (res) => {
            this.isLoading = false;
            const data = res.data;
            this.lastUpdated = this.toBangkokDateTime(
              data.lastUpdated,
              "DD/MM/YYYY HH:mm:ss"
            );
            const form = this.form;
            form.services = data.services;
            form.shifts = data.shifts;
            const shiftsByDay = {};

            form.shifts.forEach(s => {
              if (!shiftsByDay[s.day]) shiftsByDay[s.day] = {};
              shiftsByDay[s.day][s.name] = { ...s };
            });

            this.days.forEach(day => {
              if (!shiftsByDay[day.value]) shiftsByDay[day.value] = {};
              ["A", "B"].forEach(shiftName => {
                if (!shiftsByDay[day.value][shiftName]) {
                  shiftsByDay[day.value][shiftName] = {
                    name: shiftName,
                    day: day.value,
                    isActive: false,
                    startTime: "",
                    endTime: "",
                  };
                }
              });
            });

            form.shifts = [];
            this.days.forEach(day => {
              ["A", "B"].forEach(shiftName => {
                form.shifts.push(shiftsByDay[day.value][shiftName]);
              });
            });
            this.updateServiceStates();
          }
        );
      } catch (error) {
        this.requestFailure(error);
      }
    },
    async upsertCounterService(storeCode, body) {
      this.isLoading = true;
      try {
        await CounterServiceService.upsertCounterService(storeCode, body).then(
          (res) => {
            this.isLoading = false;
            const data = res.data;
            if (data.message) {
              this.message = data.message;
            } else {
              this.message = "บันทึกสำเร็จ";
            }
            this.showDialog = true;
            this.lastUpdated = this.toBangkokDateTime(
              data.lastUpdated,
              "DD/MM/YYYY HH:mm:ss"
            );
            this.form.services = data.services;
            this.updateServiceStates();
            this.showSuccess = true;
          }
        );
      } catch (error) {
        this.requestFailure(error);
      }
    },
    updateServiceStates() {
      this.serviceMasterList.forEach((service) => {
        const matchingService = this.form.services.find(
          (formService) => formService.id === service.id
        );
        if (matchingService) {
          service.isChecked = true;
          service.startDate = this.toBangkokDateTime(
            matchingService.startDate,
            "YYYY-MM-DD"
          );
          service.endDate = this.toBangkokDateTime(
            matchingService.endDate,
            "YYYY-MM-DD"
          );
        } else {
          service.startDate = null;
          service.endDate = null;
        }
      });
    },
    getServiceParams() {
      return {
        brandCode: this.brandCode,
        status: "ACTIVE",
      };
    },
    changeStartDate(service, value) {
      if (value > service.endDate) {
        service.endDate = null;
      }
    },
    changeEndDate(service, value) {
      if (value != null) {
        service.endDate = value;
      }
    },
    requestFailure(err) {
      this.isLoading = false;
      const errorData = err.response?.data;
      if (errorData.errors?.length > 0) {
        this.setErrorText(errorData.errors);
      }
      if (errorData.message) {
        this.message = errorData.message;
      } else {
        this.message = "ไม่สามารถบันทึกได้";
      }
      this.showDialog = true;
    },
    setErrorText(errors) {
      this.error.errorServiceIds = errors.find(
        (e) => e.fieldName === "serviceIds"
      );
      this.error.errorStartDate = errors.find(
        (e) => e.fieldName === "startDate"
      );
      this.error.errorEndDate = errors.find((e) => e.fieldName === "endDate");
      this.error.errorShifts = {};

      errors.forEach((e) => {
        if (e.fieldName.startsWith("isActive.")) {
          this.error.errorShifts[e.fieldName] = e;
        } else if (e.fieldName.includes(".")) {
          const parts = e.fieldName.split(".");
          if (parts.length === 3) {
            const [day, shift, field] = parts;
            if (!this.error.errorShifts[day]) {
              this.error.errorShifts[day] = {};
            }
            if (!this.error.errorShifts[day][shift]) {
              this.error.errorShifts[day][shift] = { startDate: null, endDate: null, startTime: null, endTime: null };
            }
            this.error.errorShifts[day][shift][field] = e;
          } else if (parts.length === 2) {
            const [day, field] = parts;
            if (!this.error.errorShifts[day]) {
              this.error.errorShifts[day] = {};
            }
            this.error.errorShifts[day][field] = e;
          }
        }
      });
    },
    resetErrorText() {
      this.error = {
        errorServiceIds: "",
        errorStartDate: "",
        errorEndDate: "",
        errorShifts: {},
      };
    },
    toBangkokDateTime(date, format) {
      if (!date) return null;
      return moment(date).utcOffset("+07:00").format(format);
    },
    convertToISO8601(date) {
      if (!date) return null;
      return moment(date, "yyyy-MM-DD").toISOString();
    },
    toggleAllServices(checked) {
      this.serviceMasterList.forEach(service => {
        service.isChecked = checked;
      });
    },
    toggleAllShifts(checked) {
      this.days.forEach(day => {
        this.shiftMap[day.value]['A'].isActive = checked;
        this.shiftMap[day.value]['B'].isActive = checked;
      });
    },
    toggleShifts(day, checked) {
      this.shiftMap[day]['A'].isActive = checked;
      this.shiftMap[day]['B'].isActive = checked;
    },
    applyAllShiftTimes(shiftName, sourceDay) {
      const sourceShift = this.shiftMap[sourceDay][shiftName];
      if (!sourceShift || !sourceShift.startTime || !sourceShift.endTime) return;

      this.days.forEach(day => {
        if (day.value !== sourceDay) {
          this.shiftMap[day.value][shiftName].startTime = sourceShift.startTime;
          this.shiftMap[day.value][shiftName].endTime = sourceShift.endTime;
        }
      });
    },
  },
  watch: {
    activeTab(newVal) {
      const q = { ...this.$route.query };
      delete q.kwRoom; delete q.kwStaff;
      delete q.currentPage; delete q.sortColumn; delete q.sortType;
      this.$router.replace({ query: { ...q, tab: String(newVal) } });

      if (newVal === 1) this.$refs.rooms?.clearSearch();
      if (newVal === 2) this.$refs.staffs?.clearSearch();
    }
  }

};
</script>

<style scoped lang="scss">
.custom-tabs {
  background-color: whitesmoke;
}

.custom-tabs .v-tab--active {
  background-color: #ffffff;
  color: #000000;
}

.custom-tabs .v-tab {
  background-color: whitesmoke;
  color: black;
}

.custom-tabs .v-tab:hover {
  background-color: #a1a1a1;
}

.tab-content {
  padding: 0.5rem 2rem;
  background-color: whitesmoke;
  color: #000000;
}

.tab-min-height {
  min-height: 400px;
  height: auto;
}

.time-picker-wrapper {
  width: 200px;
}

table {
  tbody tr td:first-child {
    padding-top: 1.75rem;
    vertical-align: top;
  }
}

.text-error {
  word-wrap: break-word;
  white-space: normal;
  margin-top: 0.25rem;
}
</style>
